// Copyright (C) AirWorks Solutions, Inc - All Rights Reserved
// DO NOT REDISTRIBUTE
// UNAUTHORIZED COPYING OF THIS FILE, ANY PART OR WHOLE, VIA ANY MEDIUM IS STRICTLY PROHIBITED
// PROPRIETARY AND CONFIDENTIAL

const styles = (theme: any) => ({
  subscriptionContent: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(5),
    paddingRight: theme.spacing(5),
  },
  wrapper: {
    display: 'grid',
    gridTemplateColumns: '1fr auto auto',
  },
  header: {
    marginBottom: theme.spacing(3),
  },
  dialogWrapper: {
    margin: theme.spacing(4),
  },
  divider: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  planName: {
    display: 'inline',
    fontSize: '22px',
    lineHeight: '25px',
    color: '#1C364B',
  },
  planDetails: {
    fontSize: '16px',
    lineHeight: '19px',
    marginTop: theme.spacing(2),
    color: '#484D52',
    marginRight: theme.spacing(1),
  },
  planOptions: {
    display: 'grid',
    gridTemplateColumns: '1fr auto',
    alignItems: 'center',
  },
  optionsButton: {
    color: theme.palette.primary.main,
    textTransform: 'none',
    fontSize: '16px',
    lineHeight: '19px',
    marginTop: theme.spacing(2),
  },
  cadDetails: {
    display: 'grid',
    gridTemplateColumns: 'auto auto 1fr',
    alignItems: 'center',
  },
  planRate: {
    marginTop: theme.spacing(1),
  },
  promoBanner: {
    backgroundColor: `${theme.palette.primary.main}14`,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1.5, 2),
    marginTop: theme.spacing(1.5),
  },
  promoBannerHeadline: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: '16px',
  },
  promoBannerBody: {
    color: theme.palette.primary.main,
    fontSize: '14px',
    marginTop: theme.spacing(0.5),
  },
});

export default styles;
